import { useSearchParams } from 'react-router-dom';

export const useGetSearchParam = (queryParam: string) => {
  const [searchParams] = useSearchParams();

  return searchParams.get(queryParam);
};
